<template>
    <div class="custom-actions">
        <label class="w-100">{{ label_dropdown }}</label>
        <select class="form-control" @change="goToView($event)" :value="this.item_selected" >
            <option v-for="(row,index) in select_data" :value="row.id" :key="index">{{ row.identifiable_name }}</option>
        </select>
    </div>
  </template>

<script>
    export default {
        mounted() {
            //
        },
        props: {
            select_data: {
                type: Array,
                required: true
            },
            next_view :{
                type: String,
                required : true
            },
            item_selected:{
                type: [String,Number],
                required : true
            },
            extra_param:{
                type: String,
                required : false,
                default:''
            },
            label_dropdown:{
                type: String,
                required : false
            }
        },
        methods: {
            goToView(event){
                window.location.href= "/"+this.next_view+event.target.value+this.extra_param;

            }
        }
    }
</script>

<style>
.custom-actions button.ui.button {
  padding: 8px 8px;
}
.custom-actions button.ui.button > i.icon {
  margin: auto !important;
}
</style>
